import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Injectable } from '@angular/core';
import { CategoriaEntry } from 'src/app/shared/entrys/categoria.entry';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SubCategoriaEntry } from 'src/app/shared/entrys/sub-categoria.entry';
import { DocumentoEntry } from 'src/app/shared/entrys/documento.entry';
import { VehiculoEntry } from 'src/app/shared/entrys/vehiculo.entry';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';


@Injectable()
export class TipoEstablecimientoService implements RequestCRUD<DocumentoEntry, ResponseServiceModel>  {
	private API_URL;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DocumentoDetalleSolicitud/ObtenerPorDetalleSolicitud`, entry).pipe(
			retry(2)
		);
	}

	getCamposAdicionales(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DetalleSolicitudDatosAdicionales/ObtenerDatosAdicionales`, entry).pipe(
			retry(2)
		);
	}

	getEstablecimientosPendiente(entry: RNTPrestadorEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/InformacionPendienteEdicion/ObtenerPorDetalleSolicitud`, entry).pipe(
			retry(2)
		);
	}

	getListaCheckTurismo(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/TipoTurismoAventura`, entry).pipe(
			retry(2)
		);
	}

	getDocumentoTurismo(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DetalleSolicitud/AsociarDocumentosTurismoAventura`, entry).pipe(
			retry(2)
		);
	}

	getDesasociarDocumentoTurismo(entry: any): Observable<ResponseServiceModel> {
		entry.activo = false;
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DetalleSolicitud/AsociarDocumentosTurismoAventura`, entry).pipe(
			retry(2)
		);
	}

	asociarListatipoTurismo(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DetalleSolicitudTipoTurismoAventura/AsociarLista`, entry).pipe(
			retry(2)
		);
	}

	desasociarListatipoTurismo(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DocumentoTipoTurismoAventura/DesvincularDocumentos`, entry).pipe(
			retry(2)
		);
	}

	update(entry: DocumentoEntry): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/DocumentoDetalleSolicitud/${entry.documento_id}`, entry).pipe(
			retry(2)
		);
	}

	updateCampoAdicional(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/DetalleSolicitudDatosAdicionales/Actualizar`, entry).pipe(
			retry(2)
		);
	}

	create(entry: DocumentoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	delete(entry: DocumentoEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}

	getVehiculos(numeroPagina: number, entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Vehiculo?PageNumber=${numeroPagina}&PageSize=12`, entry).pipe(
			retry(2)
		);
	}
	checkUpdateChanges(entry: any) {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/Solicitud/CheckUpdateChanges`, entry).pipe(
			retry(2)
		);
	}
}
